import React, {useReducer} from 'react';
import {ContentAdDesktop} from 'app/styles/content';
import CompetitionScorers from 'app/components/competitions/CompetitionScorers';
import {Helmet} from 'react-helmet-async';
import {TITLE_POSTFIX} from 'app/seo/seo.constants';
import {useParams} from 'react-router';
import {useDispatch} from 'react-redux';
import {useInfiniteScrollComponentState} from 'app/hooks/useInfiniteScroll';
import {fetchLeagueScorers} from 'app/routes/league/LeagueScorersPageActions';
import {LeagueScorersPageReducer} from 'app/routes/league/LeagueScorersPageReducer';
import {useRestoreData, useFetchData} from 'app/hooks/dataHooks';

const LeagueScorersPage = () => {
  const {restoredData} = useRestoreData('LeagueScorersPage');

  const params = useParams();
  const dispatchRedux = useDispatch();
  const initialState = restoredData ?? {
    scorers: [],
    error: null,
    nextUrl: '',
    isFetching: false,
    metaLeague: null,
  };
  const [state, dispatch] = useReducer(LeagueScorersPageReducer, initialState);

  const loadData = reloading =>
    fetchLeagueScorers(params.leagueSlug, params.seasonSlug, dispatchRedux, reloading)(dispatch, state);

  const {scorers, isFetching, error, metaLeague} = state;
  useInfiniteScrollComponentState(loadData, scorers.length);
  useFetchData(state, loadData, 'LeagueScorersPage');

  const headerParentName =
    params.seasonSlug && metaLeague?.season ? `${metaLeague.name} ${metaLeague.season.name}` : metaLeague?.name ?? '';

  const districtName = metaLeague?.district?.name ?? '';
  const activeLeague = metaLeague?.active;

  const title = `Torjägerliste - ${headerParentName} - ${districtName}${TITLE_POSTFIX}`;
  const robots = activeLeague ? 'index, follow' : 'noindex, follow';
  const meta = [
    {
      name: 'description',
      content: `Die aktuelle Torschützenliste absteigend nach Toren der erfolgreichsten Torjäger in der ${headerParentName} - Kreis ${districtName}.`,
    },
    {
      name: 'robots',
      content: robots,
    },
  ];

  return (
    <ContentAdDesktop noTabs top='4.5rem'>
      <Helmet title={title} meta={meta} />
      <CompetitionScorers isFetching={isFetching} scorers={scorers} error={error} />
    </ContentAdDesktop>
  );
};

export default LeagueScorersPage;
